import { registerPlugin } from '@capacitor/core';

export const TriadLink = registerPlugin('TriadLink', {
  web: () => ({
    async isAvailable() {
      return {
        available: false,
        canHost: false,
        canGuest: false,
        platform: 'web',
        l2cap: false,
        reason: 'Native P2P radio (BLE/Hotspot) not supported in standard web browser'
      };
    },
    async requestPermissions() {
      return { granted: false, missing: ['BLUETOOTH_PERMISSION'] };
    },
    async startHost() {
      throw new Error('TriadLink host is not supported on web');
    },
    async startGuest() {
      throw new Error('TriadLink guest is not supported on web');
    },
    async stop() {},
    async send() {
      return { sent: 0 };
    },
    async setKeepAwake() {},
    async getDeviceInfo() {
      return { isAmazon: false, manufacturer: 'web', brand: 'web', model: 'web' };
    },
    addListener() {
      return { remove: async () => {} };
    }
  })
});
